import { useContext, useState, useEffect, useMemo } from 'react';

//Components
import { Modal, TextField, Button, Box } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete';

//Contexts
import { UserContext } from '../Contexts/UserContext'
//Fetching
import { useMutation, useLazyQuery } from '@apollo/client';
import { INCIDENT_AUTO_SUGGEST } from '../Queries/IncidentAutoSuggest'
import { ADD_LINKED_INCIDENT } from '../Mutations/AddLinkedIncident'
import { IncidentsContext } from '../Contexts/IncidentsContext';
import { INCIDENT_ACTIONS } from '../Actions/IncidentActions';
//utils
import { shouldBeLocked } from '../utils/Roles';

const LinkIncident = ({ showLinkIncident, setShowLinkIncident, modalStyle, formStyle, fabStyle, paperStyle, incidentId, incidentIndex, disabled = undefined, userRoles, ...props }) => {
  const memoizedLocked = useMemo(() => shouldBeLocked(disabled, props?.canEdit, userRoles), [disabled, props?.canEdit, userRoles]);
  const { user } = useContext(UserContext)
  const [addLinkedIncident] = useMutation(ADD_LINKED_INCIDENT)
  const [searchValue, setSearchValue] = useState("")
  const [incidentOptions, setIncidentOptions] = useState([])
  const { incidentDispatch } = useContext(IncidentsContext)
  const { ADD_INCIDENT_TO_LINK } = INCIDENT_ACTIONS

  const [incidentAutoSuggest, { loading: incidentAutoSuggestLoading, error: incidentAutoSuggestError, data: incidentAutoSuggestData }] = useLazyQuery(INCIDENT_AUTO_SUGGEST, { context: { serializationKey: "incidentQueue" }, variables: { originatorId: user?.id }, onError: (error) => { console.error(JSON.stringify(error)) } })

  useEffect(() => {
    if (searchValue && searchValue.length > 2) {
      incidentAutoSuggest({ variables: { incidentNumber: searchValue, count: 20 } })
    }
  }, [searchValue, incidentAutoSuggest])

  useEffect(() => {
    if (incidentAutoSuggestData && !incidentAutoSuggestLoading && !incidentAutoSuggestError) {
      setIncidentOptions(incidentAutoSuggestData.incidentAutoSuggest);
    }
  }, [incidentAutoSuggestData, incidentAutoSuggestLoading, incidentAutoSuggestError])

  const handleClose = () => {
    setSearchValue("")
    setIncidentOptions([])
    setShowLinkIncident(false)
  }

  const handleKeyBlur = (event) => {
    if (event.keyCode === 27 || event.keyCode === 13) {
      handleClose();
    } else {
      return null;
    }
  }

  const handleLinkIncident = (incidentToLink) => {
    if (!incidentToLink?.id) {
      return;
    }
    addLinkedIncident({ variables: { input: { incidentId: incidentId, originatorId: user?.id, idToLink: incidentToLink.id } } })
    incidentDispatch({ type: ADD_INCIDENT_TO_LINK, payload: { incidentId: incidentId, linkedIncident: incidentToLink } })
  }

  return (
    <Modal
      open={showLinkIncident}
      onClose={() => setShowLinkIncident(false)}
      className={modalStyle}
      data-cy="linked-incident-modal"
    >
      <div className={paperStyle}>
        <Autocomplete
          id="link-incident-autocomplete"
          autoSelect
          onBlur={handleClose}
          onKeyDown={handleKeyBlur}
          autoHighlight
          options={incidentOptions}
          getOptionLabel={(option) => option?.incidentNumber || ""}
          style={{ width: 300 }}
          onInputChange={(event, newValue) => setSearchValue(newValue)}
          onChange={(event, newValue) => {
            if (!memoizedLocked && newValue?.incidentNumber && window.confirm(`Link to ${newValue.incidentNumber}?`)) {
              handleLinkIncident(newValue)
            }
          }}
          renderInput={(params) => <TextField {...params} label="Enter an incident number" variant="outlined" />}
        />
        <Box display="flex" flexDirection="row" >
          <Button style={{ width: "fit-content", marginTop: '1vh', marginBottom: '3vh', marginRight: "2vw" }} variant="contained" onClick={!memoizedLocked ? () => handleLinkIncident() : null}>Link</Button>
          <Button style={{ width: "fit-content", marginTop: '1vh', marginBottom: '3vh' }} variant="contained" onClick={handleClose}>Cancel</Button>
        </Box>
      </div>
    </Modal>
  );
}

export default LinkIncident;
